import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router';
import { Modal, Slider } from 'antd';
import { WalletContext } from '../context/WalletContext';
import faucet from '../images/faucet.svg';
import {
  unilendV2core,
  unilendV2position,
} from '../constants/contracts_sepolia.json';
import {
  add,
  sub,
  mul,
  div,
  toAPY,
  fixed2Decimals,
  toDecimals,
  numberFormat,
  greaterThan,
  lessThan,
  decimal2Fixed,
  getBorrowMax,
  getLTV,
  getCurrentLTV,
} from '../helpers/contracts';
import { getTokenLogo, getToken } from '../constants/logos';
import styled from 'styled-components';
import moment from 'moment';
import { Button, Loader } from '../UI/index';
import breakpoints from '../utils/breakpoints';
import { shortNumber } from '../utils';
import ERC20ABI from '../assets/abi-erc20.json';
import Notification from './Notification';
import './styles/Card.scss';
import BigNumber from 'bignumber.js';
import PopupModal from './twitterModal/TwitterModal';

// Constants for tabs
const lendTab = 0;
const borrowTab = 1;
const redeemTab = 2;
const repayTab = 3;

const Card = () => {
  const params = useParams();

  const {
    currentAccount,
    currentNetworkId,
    isConnected,
    accountBalance,
    uV2Core,
    uV2Helper,
    uWeb3,
    connectWallet,
  } = useContext(WalletContext);

  const [loadingPool, setLoadingPool] = useState(true);
  const [loadingFull, setLoadingFull] = useState(false);
  const [loadingOracle, setLoadingOracle] = useState(false);
  const [loadingTokens, setLoadingTokens] = useState(false);
  //
  const [currentPool, setCurrentPool] = useState(params.slug);
  const [amount, setAmount] = useState(0);
  const [valueLTV, setValueLTV] = useState(5);
  const [tokenBalance, setTokenBalance] = useState();
  const [max, setMax] = useState(false);
  //
  const [digits, setDigits] = useState('0.000');
  const [localDB, setLocalDB] = useState({
    token0: { tabs: [] },
    token1: { tabs: [] },
  });
  const [dataLoader, setDataLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedToken, setSelectedToken] = useState({}); // selected token to render the logo on click
  const [collateralToken, setCollateralToken] = useState({});
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [isCollatoralNeeded, setIsCollatoralNeeded] = useState(false);
  const [callToAction, setCallToAction] = useState({
    text: 'Enter Amount',
    disabled: false,
  });
  const [collateral, setCollateral] = useState(0);
  const [tab, setTab] = useState({
    activeObject: null,
    objects: [
      { id: 2, name: 'Lend' },
      { id: 1, name: 'Borrow' },
      { id: 3, name: 'Redeem' },
      { id: 3, name: 'Repay' },
    ],
  });
  const [activeTab, setActiveTab] = useState(0);

  const [notification, setNotification] = useState({
    message: '',
    txnId: '',
    data: {},
    visible: false,
    date: '',
  });

  const [timeStamp, setTimeStamp] = useState();
  // const [date, setDate] = useState();
  const [shareModal, setShareModal] = useState(false);
  const toggleTab = (index) => {
    setActiveTab(index);
    setAmount('');
    setLoading(false);
  };

  const getTabs = (token) => {
    if (token.lendBalance && token.lendBalance != 0) {
      return [
        { id: 0, name: 'Lend' },
        { id: 2, name: 'Redeem' },
      ];
    } else if (token.borrowBalance && token.borrowBalance != 0) {
      return [
        { id: 1, name: 'Borrow' },
        { id: 3, name: 'Repay' },
      ];
    } else {
      return [
        { id: 0, name: 'Lend' },
        { id: 1, name: 'Borrow' },
      ];
    }
  };

  const date = moment(new Date()).format('MM/DD/YYYY');

  //   setDate(
  //     new Intl.DateTimeFormat('en-US', {
  //       year: 'numeric',
  //       month: '2-digit',
  //       day: '2-digit',
  //     }).format(date)
  //   );
  // });

  useEffect(() => {
    //GET DATE

    const time = Date.now();

    setTimeStamp(
      new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).format(time)
    );
  });

  useEffect(() => {
    connectWallet();
  }, []);

  // USE EFFECT SELECTED TOKEN
  useEffect(() => {
    if (selectedToken && selectedToken.tabs && selectedToken.tabs.length) {
      setActiveTab(selectedToken.tabs[0]['id']);
    }
  }, [selectedToken, uV2Core, uV2Helper, uWeb3]);

  // USE EFFECT AMOUNT
  useEffect(() => {
    // ENTER AMOUNT
    if (!amount || amount == 0) {
      setCallToAction({ text: 'Enter Amount', disabled: true });
      setCollateral(0);
    }

    // LEND CONDITIONS
    else if (amount && activeTab == 0) {
      // ALLOWANCE
      if (
        selectedToken.allowance &&
        !greaterThan(selectedToken.allowance, '0')
      ) {
        setCallToAction({
          text: 'Approve ' + selectedToken.symbol,
          disabled: false,
        });
      } else if (amount > Number(selectedToken.balanceFixed)) {
        setCallToAction({ text: 'Low Balance in Wallet', disabled: true });
      } else {
        setCallToAction({
          text: 'Lend ' + selectedToken.symbol,
          disabled: false,
        });
      }
    }

    // BORROW CONDITIONS
    else if (amount && activeTab == 1) {
      if (
        collateralToken.allowance &&
        !greaterThan(collateralToken.allowance, '0')
      ) {
        setCallToAction({
          text: 'Approve ' + collateralToken.symbol,
          disabled: false,
        });
      } else if (greaterThan(amount, selectedToken.tokenLiquidityFixed)) {
        setCallToAction({ text: 'Not Enough Liquidity', disabled: true });
        setCollateral(0);
      } else {
        setCallToAction({
          text: 'Borrow ' + selectedToken.symbol,
          disabled: false,
        });
        getCollateralNeeded();
      }
    }

    // REDEEM CONDITIONS
    else if (amount && activeTab == 2) {
      if (Number(selectedToken.lendBalanceFixed) == 0) {
        setCallToAction({ text: 'Nothing Lent', disabled: true });
      } else if (greaterThan(amount, selectedToken.lendBalanceFixed)) {
        setCallToAction({ text: 'Not enough amount lent', disabled: true });
      } else if (greaterThan(amount, selectedToken.tokenLiquidityFixed)) {
        setCallToAction({ text: 'Not enough liquidity', disabled: true });
      } else {
        setCallToAction({
          text: 'Redeem ' + selectedToken.symbol,
          disabled: false,
        });
      }
    }

    // REPAY CONDITIONS
    else if (amount && activeTab == 3) {
      if (Number(selectedToken.borrowBalanceFixed == 0)) {
        setCallToAction({ text: 'No Amount Owed', disabled: true });
      } else if (greaterThan(amount, selectedToken.balanceFixed)) {
        setCallToAction({ text: 'Low Balance in Wallet', disabled: true });
      } else {
        setCallToAction({
          text: 'Repay ' + selectedToken.symbol,
          disabled: false,
        });
      }
    } else {
      setCallToAction({ text: 'Enter Amount', disabled: true });
    }
  }, [amount, valueLTV]);

  // USE EFFECT COLLATERAL
  useEffect(() => {
    if (
      activeTab === borrowTab &&
      collateral > Number(collateralToken.balanceFixed)
    ) {
      setCallToAction({
        text: 'Low Collateral Amount in Wallet',
        disabled: true,
      });
    }
  }, [collateral]);

  // USE EFFECT LTV SLIDER
  useEffect(() => {
    getCollateralNeeded();
  }, [uV2Core, uV2Helper, uWeb3, valueLTV, amount]);

  // USE EFFECT INITIAL
  useEffect(() => {
    if (loadingPool) {
      getPool();
    }
  }, [loadingPool, uV2Core, uV2Helper, uWeb3]);

  // USE EFFECT LOCAL DB

  useEffect(() => {
    if (Number(collateral).toFixed(12) > 0) {
      setIsCollatoralNeeded(true);
    } else {
      setIsCollatoralNeeded(false);
    }
  }, [collateral]);

  // USE EFFECT TOKENS
  useEffect(() => {
    if (loadingTokens) {
      getTokens();
    }
  }, [loadingTokens, uV2Core, uV2Helper, uWeb3]);

  // USE EFFECT ORACLE
  useEffect(() => {
    if (loadingOracle) {
      getOracle();
    }
  }, [loadingOracle, uV2Core, uV2Helper, uWeb3]);

  // USE EFFECT FULL DATA
  useEffect(() => {
    if (loadingFull) {
      getPoolFull();
    }
  }, [loadingFull, uV2Core, uV2Helper, uWeb3]);

  // USE EFFECT POOL DATA
  useEffect(() => {
    if (notification.visible) {
      let data = localStorage.getItem('notificationObject');

      data = data ? JSON.parse(data) : [];

      data.push(notification);

      localStorage.setItem('notificationObject', JSON.stringify(data));
      setTimeout(function () {
        setNotification({ visible: false, message: '', data: {}, txnId: '' });
      }, 5000);
    }
  }, [notification]);

  //

  const closeNotification = (notiObj) => {
    setNotification({ visible: false, message: '', data: {}, txnId: '' });
  };

  const toggleToken = (index) => {
    setSelectedIndex(index);
    if (index == 0) {
      let localData = localDB.token0;
      localData.index = 0;
      let collateralData = localDB.token1;
      collateralData.index = 1;
      setSelectedToken(localData);
      setCollateralToken(collateralData);
    } else if (index == 1) {
      let localData = localDB.token1;
      localData.index = 1;
      let collateralData = localDB.token0;
      collateralData.index = 0;
      setSelectedToken(localData);
      setCollateralToken(collateralData);
    }
    setAmount('');
  };

  const getPool = async () => {
    if (uV2Helper && uV2Core) {
      if (loadingPool) {
        uV2Helper.methods.getPoolData(params.slug).call((error, out) => {
          let localData = localDB;
          localData = localDB;
          localData.pool = params.slug;
          localData.lb = out.lb;
          localData.ltv = String(Number(out.ltv) - 0.01);
          localData.rf = out.rf;
          localData.token0.address = out._token0;
          localData.token1.address = out._token1;
          localData.token0.symbol = out._symbol0;
          localData.token1.symbol = out._symbol1;
          localData.token0.decimals = out._decimals0;
          localData.token1.decimals = out._decimals1;
          setLocalDB(localData);
          setLoadingPool(false);
          setLoadingFull(true);
        });
      }
    }
  };

  const getPoolFull = () => {
    if (uV2Helper && uV2Core) {
      uV2Helper.methods
        .getPoolFullData(unilendV2position, params.slug, currentAccount)
        .call((error, out) => {
          let localData = localDB;
          localData.token0.totalBorrow = out._totalBorrow0;
          localData.token1.totalBorrow = out._totalBorrow1;

          localData.token0.totalLendShare = out._totalLendShare0;
          localData.token1.totalLendShare = out._totalLendShare1;
          localData.token0.totalBorrowShare = out._totalBorrowShare0;
          localData.token1.totalBorrowShare = out._totalBorrowShare1;

          localData.token0.tokenLiquidity = out._token0Liquidity;
          localData.token0.tokenLiquidityFixed = fixed2Decimals(
            localDB.token0.tokenLiquidity,
            localDB.token0.decimals
          );
          localData.token0.tot_liquidity = numberFormat(
            localData.token0.tokenLiquidityFixed
          );

          localData.token1.tokenLiquidity = out._token1Liquidity;
          localData.token1.tokenLiquidityFixed = fixed2Decimals(
            localDB.token1.tokenLiquidity,
            localDB.token1.decimals
          );
          localData.token1.tot_liquidity = numberFormat(
            localData.token1.tokenLiquidityFixed
          );

          localData.token0.interest = out._interest0;
          localData.token1.interest = out._interest1;

          localData.token0.healthFactor = out._healthFactor0;
          localData.token1.healthFactor = out._healthFactor1;

          localData.token0.lendBalance = out._lendBalance0;
          localData.token0.lendBalanceFixed = fixed2Decimals(
            out._lendBalance0,
            localData.token0.decimals
          );
          localData.token0.lendShare = out._lendShare0;
          localData.token0.borrowBalance = out._borrowBalance0;
          localData.token0.borrowBalanceFixed = fixed2Decimals(
            out._borrowBalance0,
            localData.token0.decimals
          );
          localData.token0.borrowShare = out._borrowShare0;

          localData.token1.lendBalance = out._lendBalance1;
          localData.token1.lendBalanceFixed = fixed2Decimals(
            out._lendBalance1,
            localData.token1.decimals
          );
          localData.token1.lendShare = out._lendShare1;
          localData.token1.borrowBalance = out._borrowBalance1;
          localData.token1.borrowBalanceFixed = fixed2Decimals(
            out._borrowBalance1,
            localData.token1.decimals
          );
          localData.token1.borrowShare = out._borrowShare1;

          localData.token0.totLiqFull = add(
            div(mul(localDB.token0.tokenLiquidity, 100), localDB.rf),
            localDB.token0.totalBorrow
          );
          localData.token0.borrowApy = toAPY(
            fixed2Decimals(localDB.token0.interest, 18)
          );
          localData.token0.lendApy = div(
            localDB.token0.borrowApy,
            div(localDB.token0.totLiqFull, localDB.token0.totalBorrow)
          );
          localData.token0.health = fixed2Decimals(
            localDB.token0.healthFactor,
            18
          );
          localData.token0.healthF = greaterThan(localDB.token0.health, 100)
            ? '>100'
            : toDecimals(localDB.token0.health, 2);
          localData.token0.utilRate = toDecimals(
            mul(
              div(localDB.token0.totalBorrow, localDB.token0.totLiqFull),
              100
            ),
            2
          );
          localData.token0.lend_lp_balance = numberFormat(
            fixed2Decimals(localDB.token0.lendBalance, localDB.token0.decimals)
          );

          localData.token1.totLiqFull = add(
            div(mul(localDB.token1.tokenLiquidity, 100), localDB.rf),
            localDB.token1.totalBorrow
          );
          localData.token1.borrowApy = toAPY(
            fixed2Decimals(localDB.token1.interest, 18)
          );
          localData.token1.lendApy = div(
            localDB.token1.borrowApy,
            div(localDB.token1.totLiqFull, localDB.token1.totalBorrow)
          );
          localData.token1.health = fixed2Decimals(
            localDB.token1.healthFactor,
            18
          );
          localData.token1.healthF = greaterThan(localDB.token1.health, 100)
            ? '>100'
            : toDecimals(localDB.token1.health, 2);
          localData.token1.utilRate = toDecimals(
            mul(
              div(localDB.token1.totalBorrow, localDB.token1.totLiqFull),
              100
            ),
            2
          );
          localData.token1.lend_lp_balance = numberFormat(
            fixed2Decimals(localDB.token1.lendBalance, localDB.token1.decimals)
          );
          localData.token0.tabs = getTabs(localData.token0);
          localData.token1.tabs = getTabs(localData.token1);

          setLocalDB(localData);
          setLoadingFull(false);
          setLoadingOracle(true);
        });
    }
  };

  const getOracle = () => {
    if (uV2Helper && uV2Core) {
      uV2Core.methods
        .getOraclePrice(
          localDB.token0.address,
          localDB.token1.address,
          decimal2Fixed(1, localDB.token0.decimals)
        )
        .call((error, out) => {
          let localData = localDB;
          let tmpPrice = fixed2Decimals(out, localDB.token0.decimals);

          localData.token0.price = tmpPrice;
          localData.token1.price = div(1, tmpPrice);

          localData.token0.collateralBalance = mul(
            // div(
            mul(localData.token1.borrowBalance, localData.token1.price) /
              localData.ltv,
            // ),
            100
          );
          localData.token0.collateralBalanceFixed = fixed2Decimals(
            localData.token0.collateralBalance,
            localData.token0.decimals
          );
          let redeem0 = sub(
            localData.token0.lendBalance,
            localData.token0.collateralBalance
          );
          localData.token0.redeemBalance = redeem0 >= 0 ? redeem0 : 0;

          localData.token0.redeemBalanceFixed = fixed2Decimals(
            localData.token0.redeemBalance,
            localData.token0.decimals
          );

          localData.token1.collateralBalance = mul(
            // div(
            mul(localData.token0.borrowBalance, localData.token0.price) /
              localData.ltv,
            // ),
            100
          );
          localData.token1.collateralBalanceFixed = fixed2Decimals(
            localData.token1.collateralBalance,
            localData.token1.decimals
          );

          let redeem1 = sub(
            localData.token1.lendBalance,
            localData.token1.collateralBalance
          );
          localData.token1.redeemBalance = redeem1 >= 0 ? redeem1 : 0;
          localData.token1.redeemBalanceFixed = fixed2Decimals(
            localData.token1.redeemBalance,
            localData.token1.decimals
          );

          setLocalDB(localData);
          setLoadingOracle(false);
          setLoadingTokens(true);
        });
    }
  };

  const getTokens = () => {
    if (uV2Helper && uV2Core) {
      uV2Helper.methods
        .getPoolTokensData(params.slug, currentAccount)
        .call((error, out) => {
          let localData = localDB;
          localData.token0.balance = out._balance0;
          localData.token0.balanceFixed = fixed2Decimals(
            out._balance0,
            localData.token0.decimals
          );
          localData.token1.balance = out._balance1;
          localData.token1.balanceFixed = fixed2Decimals(
            out._balance1,
            localData.token1.decimals
          );
          localData.token0.allowance = out._allowance0;
          localData.token1.allowance = out._allowance1;
          setLocalDB(localData);
          setLoadingTokens(false);
          setDataLoader(false);
          toggleToken(selectedIndex);
        });
    }
  };

  const maxTrigger = () => {
    setMax(true);
    if (activeTab == lendTab) {
      setAmount(selectedToken.balanceFixed);
      // getBorrowMax(selectedToken, localDB);
    } else if (activeTab == borrowTab) {
      const maxBorrow = getBorrowMax(selectedToken, localDB);
      setAmount(maxBorrow);
      setValueLTV(localDB.ltv);
    } else if (activeTab == redeemTab) {
      if (
        greaterThan(
          selectedToken.tokenLiquidityFixed,
          selectedToken.redeemBalanceFixed
        )
      ) {
        setAmount(selectedToken.redeemBalanceFixed);
      } else {
        setAmount(selectedToken.tokenLiquidityFixed);
      }
    } else if (activeTab == repayTab) {
      setAmount(selectedToken.borrowBalanceFixed);
    }
  };

  const setAllowance = (token) => {
    var ERC20 = new uWeb3.eth.Contract(ERC20ABI, token.address);
    var maxAllow =
      '115792089237316195423570985008687907853269984665640564039457584007913129639935';

    ERC20.methods
      .approve(unilendV2core, maxAllow)
      .send({ from: currentAccount })
      .on('transactionHash', (hash) => {
        const txn = {
          method: 'approval',
          amount: amount,
          tokenAddress: selectedToken.address,
          tokenSymbol: selectedToken.symbol,
          poolAddress: params.slug,
          chainId: '',
          timestamp: timeStamp,
        };
        checkTxnStatus(hash, txn);
      })
      .on('error', function (error) {
        checkTxnError(error);
      });
  };

  const lend = () => {
    if (callToAction.disabled) {
      return;
    }
    setLoading(true);
    let paAmount = decimal2Fixed(amount, selectedToken.decimals);
    if (selectedToken.address == localDB.token0.address) {
      paAmount = mul(paAmount, -1);
    }

    if (uV2Core) {
      if (greaterThan(selectedToken.allowance, amount)) {
        uV2Core.methods
          .lend(localDB.pool, paAmount)
          .send({ from: currentAccount })
          .on('transactionHash', (hash) => {
            const txn = {
              method: 'lend',
              amount: amount,
              tokenAddress: selectedToken.address,
              tokenSymbol: selectedToken.symbol,
              poolAddress: params.slug,
              chainId: '',
              timestamp: timeStamp,
            }; //will hold the value of the transaction
            checkTxnStatus(hash, txn);
          })
          .on('error', function (error) {
            checkTxnError(error);
          });
      } else {
        setAllowance(selectedToken);
      }
    }
    setMax(false);
  };

  const borrow = () => {
    if (callToAction.disabled) {
      return;
    }
    setLoading(true);
    handleCloseModals();
    let paAmount = decimal2Fixed(amount, selectedToken.decimals);
    let paCollateral = decimal2Fixed(collateral, collateralToken.decimals);
    if (selectedToken.address == localDB.token0.address) {
      paAmount = mul(paAmount, -1);
    }
    if (uV2Core) {
      if (greaterThan(collateralToken.allowance, collateral)) {
        uV2Core.methods
          .borrow(localDB.pool, paAmount, paCollateral, currentAccount)
          .send({ from: currentAccount })
          .on('transactionHash', (hash) => {
            const txn = {
              method: 'borrow',
              amount: amount,
              tokenAddress: selectedToken.address,
              tokenSymbol: selectedToken.symbol,
              poolAddress: params.slug,
              chainId: '',
              timestamp: timeStamp,
            };
            checkTxnStatus(hash, txn);
          })
          .on('error', function (error) {
            checkTxnError(error);
          });
      } else {
        setAllowance(collateralToken);
      }
    }
    setMax(false);
  };

  const repay = () => {
    if (callToAction.disabled) {
      return;
    }
    setLoading(true);

    let paMax =
      '57896044618658097711785492504343953926634992332820282019728792003956564819967';
    let paAmount = decimal2Fixed(amount, selectedToken.decimals);
    if (selectedToken.address == localDB.token0.address) {
      paAmount = mul(paAmount, -1);
      // paMax = mul(paMax, -1);
      paMax = new BigNumber(
        '-57896044618658097711785492504343953926634992332820282019728792003956564819967'
      );
    }

    if (max) {
      paAmount = paMax;
    }
    if (uV2Core) {
      if (greaterThan(selectedToken.allowance, amount)) {
        uV2Core.methods
          .repay(localDB.pool, paAmount, currentAccount)
          .send({ from: currentAccount })
          .on('transactionHash', (hash) => {
            const txn = {
              method: 'repay',
              amount: amount,
              tokenAddress: selectedToken.address,
              tokenSymbol: selectedToken.symbol,
              poolAddress: params.slug,
              chainId: '',
              timestamp: timeStamp,
            };
            checkTxnStatus(hash, txn);
          })
          .on('error', function (error) {
            checkTxnError(error);
          });
      } else {
        setAllowance(selectedToken);
      }
    }
    setMax(false);
  };

  const redeem = async () => {
    if (callToAction.disabled) {
      return;
    }
    setLoading(true);
    if (uV2Core) {
      let paAmount = decimal2Fixed(amount, selectedToken.decimals);
      let paLendBal = selectedToken.lendShare;
      if (selectedToken.address == localDB.token0.address) {
        paAmount = mul(paAmount, -1);
        paLendBal = mul(paLendBal, -1);
      }
      let actnCont;
      if (max) {
        if (selectedToken.collateralBalance > '0') {
          paLendBal = selectedToken.redeemBalance;
          console.log("redeem error with .",paLendBal)
          if (selectedToken.address == localDB.token0.address) {
            paLendBal = mul(paLendBal, -1);
          }
        }
        actnCont = await uV2Core.methods.redeem(
          localDB.pool,
          paLendBal,
          currentAccount
        );
      } else {
        actnCont = await uV2Core.methods.redeemUnderlying(
          localDB.pool,
          paAmount,
          currentAccount
        );
      }

      actnCont
        .send({ from: currentAccount })
        .on('transactionHash', (hash) => {
          const txnData = {
            method: 'redeem',
            amount: amount,
            tokenAddress: selectedToken.address,
            tokenSymbol: selectedToken.symbol,
            poolAddress: params.slug,
            chainId: '',
            timestamp: timeStamp,
          };
          checkTxnStatus(hash, txnData);
        })
        .on('error', function (error) {
          checkTxnError(error);
        });
    }
    setMax(false);
  };

  const checkTxnStatus = (hash, txnData) => {
    if (uWeb3) {
      uWeb3.eth.getTransactionReceipt(hash, function (err, receipt) {
        if (receipt) {
          setLoadingFull(true);
          setAmount('');
          // change txnId to actual id from receipt
          setNotification({
            message: `Transaction for ${txnData.method} of ${txnData.amount} for token ${txnData.tokenSymbol}`,
            txnId: receipt,
            data: txnData,
            visible: true,
            date: date,
          });
          if (txnData.method !== 'approval') {
            setShareModal(true);
          }

          setLoading(false);
        } else {
          setTimeout(function () {
            checkTxnStatus(hash, txnData);
          }, 1000);
        }
      });
    }
  };

  const checkTxnError = (error) => {
    setLoading(false);
    setAmount('');
  };

  useEffect(() => {
    setAmount('');
    setValueLTV(5);
  }, [activeTab]);

  const getCollateralNeeded = () => {
    // (AmountB * PriceB) / (AmountA * PriceA)
    setCollateralToken(
      selectedToken.index == 0 ? localDB.token1 : localDB.token0
    );
    let collateralNeeded = 0;

    if (amount && collateralToken) {
      collateralNeeded = div(
        mul(
          mul(
            selectedToken.price,
            add(amount, selectedToken.borrowBalanceFixed)
          ),
          100
        ),
        valueLTV
      );
      // collateralNeeded = div(mul(add(amount, selectedToken.borrowBalanceFixed), selectedToken.price), (valueLTV/100))
      if (greaterThan(collateralToken.lendBalanceFixed, 0)) {
        if (
          lessThan(collateralToken.lendBalanceFixed, String(collateralNeeded))
        ) {
          collateralNeeded = sub(
            collateralNeeded,
            collateralToken.lendBalanceFixed
          );
        } else {
          collateralNeeded = 0;
        }
      }
    }
    setCollateral(collateralNeeded);
  };

  const handleInputChange = (e) => {
    setAmount(e.target.value);
    setMax(false);
    const LTV = getLTV(selectedToken, localDB, e.target.value);
    setValueLTV(LTV === 0 ? 5 : LTV);
  };

  const handleLTVRange = (value) => {
    const valueLtv = valueLTV > 74 ? 74 : value;
    setValueLTV(valueLtv);
    const borrowAmmount = getBorrowMax(selectedToken, localDB, valueLtv);
    const maxBorrow = getBorrowMax(selectedToken, localDB);

    if (Number(collateralToken.lendBalanceFixed) && amount <= maxBorrow) {
      setAmount(borrowAmmount >= 0 ? borrowAmmount : 0);
    }
  };

  const getInputTemplate = () => {
    return (
      <div className='main_input'>
        <div className='ticker'>
          <img
            className='ticker_imgg'
            src={getToken(selectedToken.symbol)['logo']}
          />
          <strong className='ticker_namee'>{selectedToken.symbol}</strong>
        </div>

        <div className='text-balance'>
          <div className='faucet_container'>
            <div className='head_text balance-title'>
              {(() => {
                if (activeTab == borrowTab) {
                  return <span>Borrow</span>;
                } else if (activeTab == lendTab) {
                  return <span>Lend</span>;
                } else if (activeTab == repayTab) {
                  return <span>Repay</span>;
                } else if (activeTab == redeemTab) {
                  return <span>Redeem</span>;
                }
              })()}
            </div>
            <div>
              {' '}
              <a
                href={`https://chaindrop.org/?chainid=${currentNetworkId}&token=${selectedToken.address}`}
                target='_blank'
              >
                {' '}
                <img src={faucet} alt='faucet icon' />{' '}
              </a>
            </div>
          </div>
          <div className='balance-amount'>
            Balance: {shortNumber(selectedToken.balanceFixed)}
          </div>
        </div>
        <div className='main_input_in' data-addr='' data-ex='0'>
          <div className='main_input_inn'>
            <div className='uni_input_to'></div>
          </div>
          <div className='uni_text'>
            <input
              className='input_color onlyNum amounts amount0 borrow_amount'
              placeholder=''
              value={amount}
              type='number'
              min='0'
              onWheel={(event) => event.currentTarget.blur()}
              onChange={handleInputChange}
            />
            <a>
              <span className='token_i'>
                <span className='max_btn' onClick={maxTrigger}>
                  MAX
                </span>
              </span>
            </a>
          </div>
        </div>
      </div>
    );
  };

  const getDetailsTemplate = () => {
    return (
      <div className='details'>
        <div className='detail-item'>
          <span className='detail-title'>Liquidity</span>
          <span className='detail-result'>
            {selectedToken.tot_liquidity} {selectedToken.symbol}
          </span>
        </div>
        <div className='detail-item'>
          <span className='detail-title'>Utilization</span>
          <span className='detail-result'>{selectedToken.utilRate}</span>
        </div>
        <div className='detail-item'>
          <span className='detail-title'>Oracle</span>
          <span className='detail-result'>
            1 {localDB.token1.symbol} ={' '}
            {Number(localDB.token1.price).toFixed(6)} {localDB.token0.symbol}
          </span>
        </div>
      </div>
    );
  };
  // const isCollatoralNeeded = Number(collateral) > 0;

  const getTemplate = () => {
    if (activeTab === 1) {
      return (
        // BORROW HTML
        <>
          <div className='position'>
            <div className='sm-lbl position-title'>You Borrowed</div>
            <div className='numDis' data-ex='0'>
              {shortNumber(selectedToken.borrowBalanceFixed)}
            </div>
          </div>

          {/* INPUT */}
          {getInputTemplate()}

          {/* COLLATERAL */}
          {isCollatoralNeeded ? (
            <div className='main_input_in_c collateral_bx show'>
              <div className='item'>
                <span className='coll_txt'>
                  Additional Collateral Required From Wallet
                </span>
                <br />
                <span>
                  <span className='colateral_balance'>
                    {Number(collateral).toFixed(4)}
                  </span>
                  <img
                    className='ticker_img'
                    src={getToken(collateralToken.symbol)['logo']}
                  />
                </span>
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* SLIDER */}
          <div className='ltvSlide mt-3'>
            <div className='ltvTag'>
              Current LTV
              <div className='ltvPbx'>
                <span>{getCurrentLTV(selectedToken, localDB)}%</span>
              </div>
            </div>
            <div className='ltvTag'>
              Select LTV
              <div className='ltvPbx'>
                <span className='percS v1'>{valueLTV}</span> /{' '}
                <span className='percS v2'>{localDB.ltv}</span>
              </div>
            </div>
            <div>
              <Slider
                value={Number(valueLTV)}
                defaultValue={Number(valueLTV)}
                className='ltv_slider'
                onChange={handleLTVRange}
                tooltipVisible={false}
                min={5}
                max={localDB.ltv}
              />
              {/* <input
                className="ltvRange"
                type="range"
                value={valueLTV}
                onChange={handleLTVRange}
                min='5'
                max={localDB.ltv}
              /> */}
            </div>
          </div>

          {/* DETAILS */}
          {getDetailsTemplate()}

          {/* INFO */}
          <div className='info'>
            <div className='p-2 bd-highlight text-center'>
              <div className='btStatLbl info-subtitle'>Borrow APY</div>

              <div
                className='btStatNo percS _borrowApy _apy dn _mhop info-title'
                data-ex='1'
              >
                {selectedToken.borrowApy}
              </div>
            </div>
            <div className='p-2 bd-highlight text-center'>
              <div className='btStatLbl info-subtitle'>Max LTV</div>

              <div className='btStatNo percS _maxLtv info-title'>
                {localDB.ltv}
              </div>
            </div>
            <div className='p-2 bd-highlight text-center'>
              <div className='btStatLbl info-subtitle'>Liq Bonus</div>

              <div className='btStatNo percS _lBonus info-title'>
                {localDB.lb}
              </div>
            </div>
          </div>

          <div className='call-to-action'>
            <Button
              disabled={callToAction.disabled}
              className={
                !callToAction.disabled
                  ? 'sty-btn style-active'
                  : 'sty-btn style-disable'
              }
              onClick={isCollatoralNeeded ? handleOpenModals : borrow}
            >
              {loading ? <Loader></Loader> : <span>{callToAction.text}</span>}
            </Button>
          </div>
        </>
      );
    } else if (activeTab === 0) {
      return (
        // LEND HTML
        <div className='bx_box box_lend dn'>
          <div className='position'>
            <div className='sm-lbl position-title'>Your liquidity</div>
            <div className='numDis' data-ex='0'>
              {shortNumber(selectedToken.lendBalanceFixed)}
            </div>
          </div>

          {/* INPUT */}
          {getInputTemplate()}

          {/* INFO */}
          <div className='d-flex justify-content-evenly mt-2 pool info'>
            <div className='p-2 bd-highlight text-center'>
              <div className='btStatLbl info-subtitle'>Lend APY</div>

              <div
                className='btStatNo percS _lendApy _apy _mhop info-title'
                data-ex='0'
              >
                {shortNumber(selectedToken.lendApy)}
              </div>
            </div>

            <div className='p-2 bd-highlight text-center'>
              <div className='btStatLbl info-subtitle'>Utilization rate</div>

              <div
                className='btStatNo percS _utilRate _mhop info-title'
                data-ex='0'
              >
                {shortNumber(selectedToken.utilRate)}
              </div>
            </div>
            <div className='p-2 bd-highlight text-center'>
              <div className='btStatLbl info-subtitle'>Health Factor</div>

              <div className='btStatNo _healthF _mhop info-title' data-ex='0'>
                {selectedToken.healthF}
              </div>
            </div>
          </div>

          {/* ACTION */}
          <div className='call-to-action'>
            <Button
              className={
                !callToAction.disabled
                  ? 'sty-btn style-active'
                  : 'sty-btn style-disable'
              }
              onClick={lend}
            >
              {loading ? <Loader></Loader> : <span>{callToAction.text}</span>}
            </Button>
          </div>
        </div>
      );
    } else if (activeTab === 3) {
      return (
        // REPAY HTML
        <div className='bx_box box_repay dn'>
          <div className='position'>
            <div className='sm-lbl position-title'>You owe</div>
            <div className='numDis' data-ex='0'>
              {shortNumber(selectedToken.borrowBalanceFixed)}
            </div>
          </div>

          {/* INPUT */}
          {getInputTemplate()}

          <div className='call-to-action'>
            <Button
              className={
                !callToAction.disabled
                  ? 'sty-btn style-active'
                  : 'sty-btn style-disable'
              }
              onClick={repay}
            >
              {loading ? <Loader></Loader> : <span>{callToAction.text}</span>}
            </Button>
          </div>
        </div>
      );
    } else if (activeTab === 2) {
      return (
        // REDEEM HTML
        <div className='bx_box box_redeem dn'>
          <div className='position'>
            <div className='sm-lbl position-title'>Redeemable Amount</div>
            <div className='numDis' data-ex='0'>
              {shortNumber(selectedToken.redeemBalanceFixed)}
            </div>
          </div>

          {/* INPUT */}
          {getInputTemplate()}

          {getDetailsTemplate()}

          <div className='call-to-action'>
            <Button
              className={
                !callToAction.disabled
                  ? 'sty-btn style-active'
                  : 'sty-btn style-disable'
              }
              onClick={redeem}
            >
              {loading ? <Loader></Loader> : <span>{callToAction.text}</span>}
            </Button>
          </div>
        </div>
      );
    }
  };

  const handleCloseModals = () => {
    setIsOpenConfirmModal(false);
  };
  const handleOpenModals = () => {
    if (isCollatoralNeeded && activeTab === 1) {
      setIsOpenConfirmModal(true);
    }
  };

  const ConfirmationModal = () => {
    return (
      <div className='ConfirmModel'>
        <div className='collateral_icon'>
          <img
            className='ticker_img'
            src={getToken(collateralToken.symbol)['logo']}
          />
          {collateralToken.symbol}
        </div>
        <h1> {Math.floor(collateral * 100) / 100}</h1>
        <p>
          Additional Collateral Required <br /> From Wallet
        </p>
        <div className='buttons'>
          <button onClick={handleCloseModals}>Cancel</button>
          <button onClick={borrow}>Confirm</button>
        </div>
      </div>
    );
  };

  //tabs.objects.map((elements, index)
  return (
    <>
      <div className='wrap'>
        <section className='mainSection'>
          <div className='container'>
            {!dataLoader ? (
              <>
                <CardContainer className='card-container'>
                  {localDB ? (
                    <>
                      <Tokens className='ttkBbl'>
                        <div
                          className={
                            selectedToken.address == localDB.token0.address
                              ? 'act  token-item'
                              : ' token-item'
                          }
                          data-target='lend'
                          onClick={() => {
                            toggleToken(0);
                          }}
                        >
                          <div className='logo'>
                            <img
                              className='ticker_img'
                              src={getToken(localDB.token0.symbol)['logo']}
                            />
                          </div>
                          <strong className='ticker_name'>
                            {localDB.token0.symbol}
                          </strong>
                        </div>
                        {/*  */}
                        <div
                          className={
                            selectedToken.address == localDB.token1.address
                              ? 'act  token-item'
                              : ' token-item'
                          }
                          data-target='lend'
                          onClick={() => {
                            toggleToken(1);
                          }}
                        >
                          <img
                            className='ticker_img'
                            src={getToken(localDB.token1.symbol)['logo']}
                          />
                          <strong className='ticker_name'>
                            {localDB.token1.symbol}
                          </strong>
                        </div>
                      </Tokens>
                      <CardBox className='card shadow-light-lg lift lift-lg ipBox'>
                        <div className='tabs-bx'>
                          {selectedToken && selectedToken.tabs ? (
                            selectedToken.tabs.map((elements, index) => (
                              <div
                                key={index}
                                className={
                                  activeTab == elements.id
                                    ? 'tab-li act'
                                    : 'tab-li inactive'
                                }
                                onClick={() => {
                                  toggleTab(elements.id);
                                }}
                              >
                                {elements.name}
                              </div>
                            ))
                          ) : (
                            <></>
                          )}
                        </div>
                        {getTemplate()}
                      </CardBox>
                    </>
                  ) : (
                    <></>
                  )}
                </CardContainer>

                <Notification
                  visible={notification.visible}
                  trigger={closeNotification}
                  message={notification.message}
                  hash={notification.hash}
                ></Notification>
              </>
            ) : (
              <>
                <CardContainer className='card-container'>
                  <Tokens className='ttkBbl'>
                    <div className=' token-item'>
                      <div className='logo'>
                        <img
                          className='ticker_img'
                          src='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ic2MtMWZ2bmFkei0xIGhxdFlVTyIgc3R5bGU9ImNvbG9yOiByZ2IoODYsIDkwLCAxMDUpOyI+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiPjwvY2lyY2xlPjxsaW5lIHgxPSI0LjkzIiB5MT0iNC45MyIgeDI9IjE5LjA3IiB5Mj0iMTkuMDciPjwvbGluZT48L3N2Zz4='
                        />
                      </div>
                      <strong className='ticker_name'>Loading..</strong>
                    </div>
                    {/*  */}
                    <div className=' token-item'>
                      <div className='logo'>
                        <img
                          className='ticker_img'
                          src='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ic2MtMWZ2bmFkei0xIGhxdFlVTyIgc3R5bGU9ImNvbG9yOiByZ2IoODYsIDkwLCAxMDUpOyI+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiPjwvY2lyY2xlPjxsaW5lIHgxPSI0LjkzIiB5MT0iNC45MyIgeDI9IjE5LjA3IiB5Mj0iMTkuMDciPjwvbGluZT48L3N2Zz4='
                        />
                      </div>
                      <strong className='ticker_name'>Loading..</strong>
                    </div>
                  </Tokens>
                  <CardBox>
                    <div className='tabs-bx'>
                      <div className='tab-li active'>Lend</div>
                      <div className='tab-li inactive'>Borrow</div>
                    </div>
                    <div className='position'>
                      <div className='sm-lbl position-title'>You Liquidity</div>
                      <div
                        className='numDis borrow_bal_dis borrow_lp_balance position-amount'
                        data-ex='0'
                      >
                        0
                      </div>
                    </div>
                    <div className='call-to-action'>
                      <Button
                        className='sty-btn style-disable'
                        onClick={borrow}
                      >
                        Loading...
                        <Loader></Loader>
                      </Button>
                    </div>
                  </CardBox>
                </CardContainer>
              </>
            )}
          </div>
        </section>
      </div>
      <Modal
        className='antd_modal_overlay'
        visible={isOpenConfirmModal}
        centered
        onCancel={handleCloseModals}
        footer={null}
        closable={false}
      >
        {<ConfirmationModal />}
      </Modal>

      <Modal
        className='antd_modal_overlay'
        visible={shareModal}
        onCancel={() => setShareModal(false)}
        centered
        footer={null}
        closable={false}
      >
        <PopupModal />
      </Modal>
    </>
  );
};

export default Card;

const CardContainer = styled.div`
  margin: auto;
  padding: 50px 0;
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }

  @media only screen and ${breakpoints.device.max_sm} {
    width: 100%;
    padding: 30px 0;
  }

  /* .vec1 {
    position: absolute;
    top: 10%;
    left: 0;
  }

  .vec2 {
    position: absolute;
    top: 42.53%;
    left: 0;
  }

  .vec3 {
    position: absolute;
    top: 10%;
    right: 0;
  }

  .vec4 {
    position: absolute;
    top: 42.53%;
    right: 0;
  } */
`;

const Tokens = styled.div`
  padding: 10px;
  height: 75.31px;
  background: #fff;
  border-radius: 12.8368px;
  box-shadow: rgb(0 0 0 / 8%) 0px 6px 10px;
  margin: 10px auto;
  display: flex;
  justify-content: space-around;

  .token-item {
    font-size: 22px;
    border-radius: 9.61197px;
    cursor: pointer;
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    border: 0.802332px solid #e6eef9;
    border-radius: 9.61197px;

    .logo {
      border-radius: 50%;
      background: #fff;
      padding: 2px;
      width: 30px;
      height: 30px;
      @media only screen and ${breakpoints.device.max_sm} {
        width: 35px;
        height: 30px;
      }
    }

    &:hover {
      background: #f6f7fa;
      border-radius: 1px solid #f6f7fa;
    }
    &.act {
      background: #0045ff;

      strong {
        color: #fff;
      }
    }
  }

  @media only screen and ${breakpoints.device.max_sm} {
    padding: 20px;
    /* margin-top: 100px; */
    max-width: 90%;
    /* margin-bottom: 25px; */

    .token-item {
      padding: 19px;
      .logo {
        /* margin-right: 5px; */
        width: 27px;
        height: 27px;
        img {
          /* width: 3.3rem; */
          vertical-align: top;
        }
      }

      strong {
        /* font-size: 3.3rem; */
      }
    }
  }

  @media only screen and ${breakpoints.device.lg} {
    padding: 15px 38px;
    max-width: 445px;
    margin-top: 0px;
  }
`;

const CardBox = styled.div`
  width: 451px;
  height: fit-content;
  margin: auto;
  background: #fff;
  border-radius: 12.8368px;
  padding: 27px 36px;
  margin-bottom: 50px;
  @media only screen and ${breakpoints.device.max_sm} {
    max-width: 90%;
    padding: 18px;
  }

  .tabs-bx {
    @media only screen and ${breakpoints.device.max_sm} {
      display: flex;
      justify-content: space-between;
      margin: 0;
      margin-bottom: 2.5rem;
      align-items: center;
      width: 100%;
      padding: 10px;
    }
    .tab-li {
      @media only screen and ${breakpoints.device.max_sm} {
        font-size: 22px;
        padding: 20px 25px;
      }
    }
  }

  .position {
    margin-bottom: 1rem;
    @media only screen and ${breakpoints.device.max_sm} {
      margin-bottom: 1.5rem;
    }

    .position-title {
      @media only screen and ${breakpoints.device.max_sm} {
        font-size: 18px;
      }
    }
    .position-amount {
      text-overflow: ellipsis;
      max-width: 200px;
      margin: auto;
      overflow: hidden;
      white-space: nowrap;

      @media only screen and ${breakpoints.device.max_sm} {
        max-width: 500px;
        font-size: 25px !important;
      }
    }
  }

  .main_input {
    z-index: 1;
    border-radius: 20px;
    width: 100%;
    text-align: -webkit-center;
    .main_input_in {
      width: 377.64px;
      height: 51.87px;
      box-shadow: inset 0px 0px 1px #ebebeb, inset 1px 1.3833px 1px #ededed;
      border-radius: 5.77909px;
      padding: 10px;
      background: #e6eef9;

      @media only screen and ${breakpoints.device.max_sm} {
        padding: auto;
        height: auto;
        width: auto;
      }
    }

    .main_input_inn {
      font-size: 0.75em;
      display: flex;
      color: rgb(0, 0, 0);

      @media only screen and ${breakpoints.device.max_sm} {
        font-size: 1.8em;
        margin-bottom: 0px;
      }

      .balance-title {
        @media only screen and ${breakpoints.device.max_sm} {
        }
      }

      .balance-amount {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        @media only screen and ${breakpoints.device.max_sm} {
          font-size: 12px;
        }
      }
    }

    .uni_text {
      .input_color {
        margin-right: 10px;
        font-weight: 700;
        @media only screen and ${breakpoints.device.max_sm} {
          /* font-size: 4.1rem; */
        }
      }
      .max_btn {
        color: #0045ff;
        @media only screen and ${breakpoints.device.max_sm} {
          font-size: 15px;
        }
      }
      .ticker_img {
        @media only screen and ${breakpoints.device.max_sm} {
          /* font-size: 2.3rem; */
          width: 25px;
          height: 25px;
        }
      }
      .ticker_name {
        @media only screen and ${breakpoints.device.max_sm} {
          /* font-size: 2.3rem; */
          padding-left: 5px;
          margin: auto;
        }
      }
    }
  }

  .info {
    margin: 0px;
    @media only screen and ${breakpoints.device.max_sm} {
    }

    .info-title {
      text-overflow: ellipsis;
      max-width: 80px;
      margin: auto;
      overflow: hidden;
      white-space: nowrap;
      @media only screen and ${breakpoints.device.max_sm} {
        max-width: 120px;
        /* font-size: 2.3rem; */
      }

      &.percS {
        &::after {
          @media only screen and ${breakpoints.device.max_sm} {
            /* font-size: 2.3rem; */
          }
        }
      }
    }

    .info-subtitle {
      @media only screen and ${breakpoints.device.max_sm} {
        font-size: 15px;
        margin: 20px 0 8px 0;
      }
    }
  }

  .collateral_bx {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 70px;

    @media only screen and ${breakpoints.device.max_sm} {
      height: 100px;
    }

    .item {
      .coll_txt {
        margin-bottom: 10px;
      }
      span {
        @media only screen and ${breakpoints.device.max_sm} {
          font-size: 20px;
        }
      }
    }
  }

  .details {
    padding: 14px;
    border-radius: 12px;
    background: #e6eef9;
    margin-top: 30px;
    @media only screen and ${breakpoints.device.max_sm} {
      padding: 30px 30px;
      margin: 2rem 0;
    }

    .detail-item {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      &:last-child {
        margin-bottom: 0px;
      }

      .title {
        font-weight: 700;
      }

      span {
        font-size: 14px;
        @media only screen and ${breakpoints.device.max_sm} {
          /* font-size: 1.8rem; */
        }
      }
    }
  }

  .call-to-action {
    margin-top: 30px;
    button {
      cursor: pointer;
      &.active {
        &:hover {
          box-shadow: rgb(0 0 0 / 8%) 0px 6px 10px;
        }
      }

      @media only screen and ${breakpoints.device.max_sm} {
        padding: 25px 30px;
        font-size: 27px;
        width: 100%;
      }
    }
  }
`;
